import { render } from "./HelpDialog.vue?vue&type=template&id=2127a834&scoped=true&ts=true"
import script from "./HelpDialog.ts?vue&type=script&lang=ts"
export * from "./HelpDialog.ts?vue&type=script&lang=ts"

import "./HelpDialog.vue?vue&type=style&index=0&id=2127a834&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2127a834"]])

export default __exports__